import React, { useState } from 'react';
import './OpportunityNavbar.css'; // Custom CSS for Opportunity-specific Navbar

const OpportunityNavbar = ({ onButtonClick }) => {
  const [activeButton, setActiveButton] = useState('');

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
    onButtonClick(buttonName);
  };

  return (
    <div className="navbar">
      <button 
        className={`navbar-button ${activeButton === 'Analyse Sections' ? 'active' : ''}`} 
        onClick={() => handleButtonClick('Analyse Sections')}
      >
        Analyse Sections
      </button>
      <button 
        className={`navbar-button ${activeButton === 'Log out' ? 'active' : ''}`} 
        onClick={() => handleButtonClick('Log out')}
      >
        Log out
      </button>
    </div>
  );
};

export default OpportunityNavbar;
